import uniqueSessionLight from "../../../../contents/images/docs/user-guides/sessions/unique-sessions-light-mode.png";
import uniqueSessionDark from "../../../../contents/images/docs/user-guides/sessions/unique-sessions-dark-mode.png";
import sessionFormulaLight from "../../../../contents/images/docs/user-guides/sessions/session-formula-light-mode.png";
import sessionFormulaDark from "../../../../contents/images/docs/user-guides/sessions/session-formula-dark-mode.png";
import durationFilterLight from "../../../../contents/images/docs/user-guides/sessions/duration-filter-light-mode.png";
import durationFilterDark from "../../../../contents/images/docs/user-guides/sessions/duration-filter-dark-mode.png";
import medianDurationLight from "../../../../contents/images/docs/user-guides/sessions/median-duration-light-mode.png";
import medianDurationDark from "../../../../contents/images/docs/user-guides/sessions/median-duration-dark-mode.png";
import durationBreakdownLight from "../../../../contents/images/docs/user-guides/sessions/duration-breakdown-light-mode.png";
import durationBreakdownDark from "../../../../contents/images/docs/user-guides/sessions/duration-breakdown-dark-mode.png";
import * as React from 'react';
export default {
  uniqueSessionLight,
  uniqueSessionDark,
  sessionFormulaLight,
  sessionFormulaDark,
  durationFilterLight,
  durationFilterDark,
  medianDurationLight,
  medianDurationDark,
  durationBreakdownLight,
  durationBreakdownDark,
  React
};